function getKioskWebBaseUrl(): string {
  const raw = import.meta.env.VITE_KIOSK_WEB_BASE_URL?.trim();
  return raw ? raw.replace(/\/$/, "") : "http://localhost:8081";
}

export function buildKioskActivityPreviewUrl(activityId: string): string {
  return `${getKioskWebBaseUrl()}/activity/${activityId}?preview=1`;
}
